import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { api } from '../../../services/api.js';
import Swal from 'sweetalert2';
import { FaUtensils, FaStore, FaClock, FaCheckCircle, FaTimes } from 'react-icons/fa';

const CardapioPopup = ({ usuario, restaurante, onClose, onConfirm, onCancelar }) => {
  const [cardapio, setCardapio] = useState([]);
  const [lojas, setLojas] = useState([]);
  const [opcao, setOpcao] = useState('');
  const [loja, setLoja] = useState('');
  const [turno, setTurno] = useState('0');
  const [observacao, setObservacao] = useState('');
  const [tipoRefeicao, setTipoRefeicao] = useState('');
  const [loading, setLoading] = useState(false);

  const limparCampos = () => {
    setOpcao('');
    setLoja('');
    setTurno('0');
    setObservacao('');
    setTipoRefeicao('');
  };

  useEffect(() => {
    const lojaUsuario = localStorage.getItem("loja");
    limparCampos();

    if (restaurante) {
      api.get(`/restaurante/${usuario}/cardapio?codigo=${restaurante.codigo}`)
        .then(res => {
          if (Array.isArray(res.data)) setCardapio(res.data);
          else setCardapio([]);
        })
        .catch(() => setCardapio([]));

      api.get(`/restaurante/${usuario}/loja?loja=${lojaUsuario}&codigo=${restaurante.codigo}`)
        .then(res => setLojas(Array.isArray(res.data) ? res.data : []))
        .catch(() => setLojas([]));
    }
  }, [restaurante, usuario]);

  const handleEnviar = async () => {
    if (loading) return;
    setLoading(true);

    const lojaSelecionada = lojas.find(l => l.loja == loja);

    const payload = {
      usuario,
      acao: 'INSERIR',
      codigo: restaurante.codigo,
      marmitex: tipoRefeicao === 'M' ? '1' : '0',
      opcao: tipoRefeicao === 'M' ? opcao : '',
      observacao,
      status: 0,
      valor: lojaSelecionada?.valor,
      loja,
      turno
    };

    try {
      const res = await api.post(`/restaurante/${usuario}`, payload);

      if (res.status === 201) {
        Swal.fire({
          icon: 'success',
          title: 'Pedido enviado!',
          text: 'Seu pedido foi registrado com sucesso.',
          confirmButtonColor: '#8b0000'
        });

        onConfirm({ restaurante, ...payload });
        onClose();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: res.data?.mensagem || 'Erro ao registrar pedido',
          confirmButtonColor: '#8b0000'
        });
      }

    } catch (err) {
      let msg = 'Falha na comunicação com o servidor';
      if (err.response?.data?.erro) {
        msg = Array.isArray(err.response.data.erro)
          ? err.response.data.erro[0]
          : err.response.data.erro;
      }

      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: msg,
        confirmButtonColor: '#8b0000'
      });

    } finally {
      setLoading(false);
    }
  };

  const lojaSelecionada = lojas.find(l => l.loja == loja);
  const permiteMarmitex = lojaSelecionada?.marmitex === 1;

  return (
    <Modal
      show={!!restaurante}
      onHide={onClose}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
      className="rounded-4 overflow-hidden"
    >
      <div className="d-flex flex-column" style={{ maxHeight: '90vh' }}>
        <Modal.Header className="bg-danger text-white border-0 p-3 p-md-4" style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)' }}>
          <Modal.Title className="fw-bold fs-5 text-white d-flex align-items-center">
            <FaUtensils className="me-2" /> {restaurante?.nomeamigavel}
          </Modal.Title>
          <button type="button" className="btn-close btn-close-white" aria-label="Fechar" onClick={onClose}></button>
        </Modal.Header>

        <Modal.Body className="p-3 p-md-4" style={{ overflowY: 'auto', flex: 1 }}>
          <Form>
            {/* SELEÇÃO DE LOJA */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold extra-small text-muted d-flex align-items-center">
                <FaStore className="me-1 text-danger" /> Loja do Pedido *
              </Form.Label>
              <Form.Select 
                className="form-select-sm fw-semibold"
                value={loja} 
                onChange={e => {
                  setLoja(e.target.value);
                  setTipoRefeicao('');
                  setOpcao('');
                }}
              >
                <option value="">Selecione a loja...</option>
                {lojas.map(l => (
                  <option key={l.loja} value={l.loja}>
                    Loja {String(l.loja).padStart(2, '0')}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* TIPO DE REFEIÇÃO */}
            {permiteMarmitex && (
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold extra-small text-muted">Tipo de Refeição *</Form.Label>
                <Form.Select 
                  className="form-select-sm fw-semibold"
                  value={tipoRefeicao} 
                  onChange={e => setTipoRefeicao(e.target.value)}
                >
                  <option value="">Selecione...</option>
                  <option value="M">Marmitex</option>
                  <option value="R">Restaurante Local</option>
                </Form.Select>
              </Form.Group>
            )}

            {/* CARDÁPIO DISPONÍVEL */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold extra-small text-muted">Opções de Cardápio</Form.Label>
              <div className="border rounded-3 p-3 bg-light" style={{ maxHeight: 220, overflowY: 'auto' }}>
                {cardapio.length === 0 ? (
                  <span className="text-muted extra-small">Nenhum item cadastrado no cardápio de hoje.</span>
                ) : (
                  cardapio.map(item => (
                    tipoRefeicao === 'M' && permiteMarmitex ? (
                      <div key={item.opcao} className="form-check py-1">
                        <input
                          type="radio"
                          className="form-check-input"
                          name="opcao"
                          id={`opcao-${item.opcao}`}
                          value={item.opcao}
                          checked={opcao === String(item.opcao)}
                          onChange={e => setOpcao(e.target.value)}
                        />
                        <label className="form-check-label small fw-medium text-dark" htmlFor={`opcao-${item.opcao}`}>
                          <strong className="text-danger">Opção {item.opcao}:</strong> {item.menu}
                        </label>
                      </div>
                    ) : (
                      <div key={item.opcao} className="py-1 border-bottom small">
                        <strong className="text-danger">Opção {item.opcao}:</strong> {item.menu}
                      </div>
                    )
                  ))
                )}
              </div>
            </Form.Group>

            {/* SELEÇÃO DE TURNO */}
            {tipoRefeicao === 'M' && (
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold extra-small text-muted d-flex align-items-center">
                  <FaClock className="me-1 text-danger" /> Turno de Entrega
                </Form.Label>
                <Form.Select className="form-select-sm fw-semibold" value={turno} onChange={e => setTurno(e.target.value)}>
                  <option value="0">1º Turno</option>
                  <option value="1">2º Turno</option>
                </Form.Select>
              </Form.Group>
            )}

            {/* OBSERVAÇÃO */}
            <Form.Group className="mb-2">
              <Form.Label className="fw-bold extra-small text-muted">Observações adicionais</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                className="form-control-sm"
                value={observacao}
                onChange={e => setObservacao(e.target.value)}
                placeholder="Ex: Sem cebola, caprichar na farofa..."
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer className="border-top bg-light p-3 d-flex justify-content-between">
          <Button variant="outline-secondary" className="btn-sm fw-bold px-3 rounded-3" onClick={onCancelar}>
            Cancelar
          </Button>
          <Button
            className="btn-sm fw-bold px-4 rounded-3 text-white border-0 d-inline-flex align-items-center gap-1.5"
            style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}
            onClick={handleEnviar}
            disabled={
              loading ||
              !loja ||
              (permiteMarmitex && !tipoRefeicao) ||
              (permiteMarmitex && tipoRefeicao === 'M' && !opcao)
            }
          >
            {loading ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                Gravando...
              </>
            ) : (
              <><FaCheckCircle size={14} /> Confirmar Pedido</>
            )}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default CardapioPopup;